import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowRight } from "lucide-react";
import { api, fmtDateTime } from "@/lib/api";

export const HomeComunicazioni = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/comunicazioni").then((r) => setItems(r.data.slice(0, 3))).catch(() => setItems([]));
  }, []);
  if (!items.length) return null;
  return (
    <section className="mt-12" data-testid="home-comunicazioni">
      <div className="flex items-end justify-between mb-4">
        <h2 className="font-heading text-3xl uppercase text-[#0B192C]">Ultime comunicazioni</h2>
        <Link to="/comunicazioni" className="text-sm text-emerald-700 hover:underline" data-testid="home-comunicazioni-all-link">Tutte le comunicazioni</Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {items.map((c, i) => (
          <Link key={c.id} to={`/comunicazioni?id=${c.id}`} style={{ animationDelay: `${i * 60}ms` }} data-testid={`home-comunicazione-${c.id}`}
            className="fade-up group bg-white border border-slate-200 border-l-4 border-l-emerald-600 rounded-xl p-5 hover:shadow-lg transition-shadow flex flex-col">
            <div className="flex items-center gap-2 text-xs font-mono-x uppercase tracking-wider text-muted-foreground">
              <Mail className="h-4 w-4 text-emerald-700" />{fmtDateTime(c.created_at)}
            </div>
            <h3 className="font-heading text-xl uppercase leading-tight mt-2 text-[#0B192C]">{c.oggetto}</h3>
            <p className="text-sm text-slate-600 mt-2 line-clamp-2">{c.estratto}</p>
            <span className="mt-auto pt-3 text-sm text-emerald-700 font-medium inline-flex items-center gap-1">Leggi <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /></span>
          </Link>
        ))}
      </div>
    </section>
  );
};
